export const TAG_TYPES = {
    NEWS: 'News',
    CARDS: 'Cards',
    FACTIONS: 'Factions',
    DECKS: 'Decks',
    USER: 'User',
    SESSIONS: 'Sessions',
    BLOCKLIST: 'Blocklist',
    ADMIN: 'Admin',
    BANLIST: 'Banlist',
    CHALLONGE: 'Challonge',
    GAMES: 'Games',
    LOBBY: 'Lobby'
};
